import { toggle } from "../utils/ui-helpers.js";


/**
 * 
 * @param {HTMLInputElement} dropdownInputEl - the customn dropdowns inner input element
 * @returns 
 */
function resetDropdown(dropdownInputEl, doDispatchChangeEvent = false) {    
    if (!dropdownInputEl) return;

    removeDropdownMessage(dropdownInputEl);

    // clear both the selected ID and the value - clearing the value shows the placeholder text again
    dropdownInputEl.value = "";
    dropdownInputEl.dataset.selectedId = 0;

    if (doDispatchChangeEvent) {
        // Trigger change events
        dropdownInputEl.dispatchEvent(new Event('change', { bubbles: true }));
        dropdownInputEl.dispatchEvent(new Event('onchange', { bubbles: true }));
    }
}

function setDropdownMessage(dropdownInputEl, message) {
    if (!dropdownInputEl) return;

    const dropdownListEl = dropdownInputEl.parentElement.querySelector('ul');
    if (!dropdownListEl) return;

    removeDropdownMessage(dropdownInputEl);

    const messageOption = document.createElement('li');
    messageOption.className = 'atb-select-option py-2 px-3 atb-dropdown-message';
    messageOption.dataset.value = '0';
    messageOption.setAttribute('role', 'option');
    messageOption.setAttribute('aria-disabled', 'true');
    messageOption.textContent = message;
    dropdownListEl.appendChild(messageOption);

    dropdownInputEl.value = message;
    dropdownInputEl.dataset.selectedId = 0;
}

function removeDropdownMessage(dropdownInputEl) {
    dropdownInputEl
        .parentElement
        ?.querySelectorAll('.atb-dropdown-message')
        .forEach(option => option.remove());
}


/**
 * Takes the custom dropdown input element and a value, searches the corresponding unordered list for that value
 * and sets the value in the given input element only if it is an existing option in the list.
 * 
 * @param {*} dropdownInputEl - the dropdown's input element - JQuery object (for now)
 * @param {*} value - the value to set the dropdown to
 */
const setDropdown = (dropdownInputEl, value, doDispatchChangeEvent = true) => {
    // Find the <ul> inside the same parent
    const dropdownListEl = dropdownInputEl.parentElement.querySelector('ul');
    if (!dropdownListEl) return;

    // Find matching option
    const matchedOption = findMatchingOption(dropdownListEl, value);
    if (!matchedOption) return;

    // Set visible text value
    dropdownInputEl.value = matchedOption.textContent;

    // Set data-selected-id
    dropdownInputEl.dataset.selectedId = matchedOption.dataset.value;    

    if (doDispatchChangeEvent) {
        // Trigger change events
        dropdownInputEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
}


// options.forEach(option => {
//         const optionParentId = option.dataset.parent;
//         const doShow = optionParentId == parentId;
//         toggle(option, doShow, displayStyle);
//     });


/**
 * 
 * @param {*} dropdownId 
 * @param {*} parentId 
 * @param {*} displayStyle 
 */
const showDropdownOptsByParentId = (dropdownId, parentId, displayStyle = "block") => {    
    // DOM dataset values are strings; presets can supply numeric IDs.
    const parentIdString = String(parentId);
    toggleDropdownOptions(dropdownId, option => option.dataset.parent === parentIdString, displayStyle);
}

/**
 * Show dropdown options matching the items in the given array.
 * 
 * @param {*} options 
 * @param {Array} visibleItems - an array of items, each must have an id property - ({id: number) 
 */
function showDropdownOptsInArray(dropdownId, visibleItems) {    
    const visibleIds = new Set(
        visibleItems.map(item => String(item.id))
    );

    toggleDropdownOptions(dropdownId, option => visibleIds.has(option.dataset.value));
}

/**
 * Adds pitch dimensions to sub-unit labels when enabled on the selected parent unit.
 */
function updateSubUnitPitchSizeLabels(showPitchSize, subUnits = []) {
    const subUnitsById = new Map(
        (Array.isArray(subUnits) ? subUnits : [])
            .map(subUnit => [String(subUnit.id), subUnit])
    );
    const shouldShowPitchSize = parseInt(showPitchSize, 10) === 1;

    document
        .querySelectorAll('#atb-sub-unit-dropdown-values li.atb-select-option:not(.atb-dropdown-message)')
        .forEach(option => {
            const subUnit = subUnitsById.get(option.dataset.value);
            if (!subUnit) return;

            const name = String(subUnit.name ?? '').trim();
            const width = String(subUnit.pitch_size_width ?? '').trim();
            const depth = String(subUnit.pitch_size_depth ?? '').trim();
            let label = name;

            if (shouldShowPitchSize && parseFloat(width) > 0) {
                label += ` - PITCH AREA ${width}M (w)`;
                if (depth !== '') {
                    label += ` x ${depth}M (d)`;
                }
            }

            option.textContent = label;
            option.setAttribute('aria-label', label);
        });
}


/**
 * Generic dropdown option toggler using a predicate function to determine visibility of each option.
 * 
 * @param {*} dropdownId 
 * @param {(option: HTMLElement) => boolean} shouldShowFn
 * @param {*} displayStyle 
 */
const toggleDropdownOptions = (dropdownId, shouldShowFn, displayStyle = "block") => {
    document
        .querySelectorAll(`#atb-${dropdownId}-dropdown-values .atb-dropdown-message`)
        .forEach(option => option.remove());

    const options = document.querySelectorAll(`#atb-${dropdownId}-dropdown-values li`);

    options.forEach(option => {
        const doShow = shouldShowFn(option);
        toggle(option, doShow, displayStyle);
    });
}


/**
 * Dynamically sets whether or not a dropdown is required for a form to be completed.
 * Used on the "county" and "state" dropdowns.
 * 
 * @param {HTMLDivElement} dropdownWrapperEl 
 * @param {boolean} isValid 
 */
function toggleDropdownValidation(dropdownWrapperEl, isRequired) {
    const boolString = isRequired ? "true" : "false";

    dropdownWrapperEl.setAttribute('aria-required', boolString);
    dropdownWrapperEl.querySelector('input').required = isRequired;
}


export { 
    resetDropdown, 
    setDropdown, 
    setDropdownMessage,
    showDropdownOptsByParentId, 
    showDropdownOptsInArray,
    updateSubUnitPitchSizeLabels,
    toggleDropdownOptions,
    toggleDropdownValidation
};
